<template>
    <div class="checklist-wrapper">
        <div>
            <div class="row gutters mb-0">
                <div class="col-sm-12">
                    <div class="card mb-0">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="field-wrapper">
                                        <div class="field-placeholder">Frequency *</div>
                                        <select
                                            class="form-control"
                                            v-model="meta.frequency_id"
                                            :class="{ 'is-invalid': errors.frequency_id }"
                                            @change="updateFromDateToDate"
                                        >
                                            <option value="">Select Frequency</option>
                                            <option
                                                v-for="(frequency, key) in frequencies"
                                                :key="key"
                                                :value="frequency.frequency_id"
                                            >
                                                {{ frequency.frequency_name }}
                                            </option>
                                        </select>
                                        <span v-if="errors.frequency_id" class="invalid-feedback"
                                            >{{ errors.frequency_id[0] }}</span
                                        >
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="field-wrapper">
                                        <div class="field-placeholder">From Date *</div>
                                        <input
                                            class="form-control"
                                            v-model="meta.from_date"
                                            :class="{ 'is-invalid': errors.from_date }"
                                            disabled
                                            type="date"
                                        />
                                        <span v-if="errors.from_date" class="invalid-feedback"
                                            >{{ errors.from_date[0] }}</span
                                        >
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="field-wrapper">
                                        <div class="field-placeholder">To Date *</div>
                                        <input
                                            class="form-control"
                                            v-model="meta.to_date"
                                            :class="{ 'is-invalid': errors.to_date }"
                                            disabled
                                            type="date"
                                        />
                                        <span v-if="errors.to_date" class="invalid-feedback"
                                            >{{ errors.to_date[0] }}</span
                                        >
                                    </div>
                                </div>
                                <div class="col-sm-3 mt-2">
                                    <button
                                        type="button"
                                        class="btn btn-primary ms-1"
                                        @click="getClusterFrequenceCompliance"
                                    >
                                        Generate
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="checklist-content">
            <div class="checklist-sticky-section" v-if="frequency_compliance != null">
                <div class="row gutters">
                    <div class="col-sm-12">
                        <h5>Overall Compliance :: {{ frequency_name }} Checklist</h5>
                        <div class="dashboard-header">
                            <div class="dashboard-header-content">
                                <div class="sales-tile-container">
                                    <div
                                        class="sales-tile"
                                        :style="{ background: getColor(frequency_compliance) }"
                                        @click="getClusterPlantCompliance"
                                    >
                                        <h4 id="label">{{ frequency_compliance }}%</h4>
                                        <h6>{{ frequency_name }}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row gutters mt-3" v-if="plants.length != 0">
                <div class="col-sm-12">
                    <h5>Plants : {{ frequency_name }}</h5>
                    <div class="dashboard-header">
                        <div class="dashboard-header-content">
                            <div class="sales-tile-container">
                                <template v-for="plant in plants" :key="plant.plant_id">
                                    <div
                                        class="sales-tile"
                                        :style="{ background: getColor(plant.compliance) }"
                                        @click="getClusterDepartmentCompliance(plant.plant_id, plant.plant_code)"
                                    >
                                        <h4 id="label">
                                            {{ plant.compliance }}<span v-if="plant.compliance != 'NA'">%</span>
                                        </h4>
                                        <h6>{{ plant.plant_code }}</h6>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row gutters mt-3" v-if="departments.length != 0">
                <div class="col-sm-12">
                    <h5>Departments : {{ plant_code }}</h5>
                    <div class="dashboard-header">
                        <div class="dashboard-header-content">
                            <div class="sales-tile-container">
                                <template v-for="department in departments" :key="department.department_id">
                                    <div
                                        class="sales-tile"
                                        :style="{ background: getColor(department.compliance) }"
                                        @click="selectDepartment(department)"
                                    >
                                        <h4 id="label">{{ department.compliance }}%</h4>
                                        <h4 id="label">{{ department.deviated_componenets }}</h4>
                                        <h6>{{ department.department_name }}</h6>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row gutters mt-3" v-if="meta.department_id">
                <div class="col-sm-12">
                    <div class="d-flex justify-content-between">
                        <h5>
                            Deviated Components ({{ deviated.totalRows }}) : {{ plant_code }} : {{ department_name }}
                        </h5>
                        <div class="d-flex align-items-center">
                            <div class="field-wrapper me-3" style="min-width: 180px">
                                <select
                                    class="form-control"
                                    v-model="deviationFilter"
                                    @change="onDeviationFilterChange"
                                >
                                    <option value="all">All Deviations</option>
                                    <option value="my">My Deviations</option>
                                </select>
                            </div>

                            <button
                                type="button"
                                class="btn btn-warning me-2"
                                :disabled="selectedComponents.length === 0"
                                data-bs-toggle="modal"
                                data-bs-target="#multiRemarkModal"
                                @click="openMultiRemarkModal"
                            >
                                Update Remarks
                            </button>

                            <button
                                v-if="['Admin', 'Super Admin'].includes($store.getters.user?.role?.role_name)"
                                type="button"
                                class="btn btn-info"
                                :disabled="selectedComponents.length === 0"
                                data-bs-toggle="modal"
                                data-bs-target="#assignUserModal"
                                @click="openAssignUserModal"
                            >
                                Assign User
                            </button>
                        </div>
                    </div>
                    <div
                        class="card"
                        v-if="
                            deviated_components.length > 0 ||
                            (akxaChecklistNoApi && meta.department_id && deviationFilter === 'all')
                        "
                    >
                        <div class="card-body">
                            <div class="table-responsive tabletop">
                                <table class="table table-sm table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>
                                                <input
                                                    type="checkbox"
                                                    @change="toggleSelectAll"
                                                    :checked="allSelected"
                                                />
                                            </th>
                                            <th>#</th>
                                            <th class="text-center">Action</th>
                                            <th>Template Name</th>
                                            <th>Equipment</th>
                                            <th>Date Time</th>
                                            <th>Component Type</th>
                                            <th>Check Type</th>
                                            <th>Default</th>
                                            <th>Value</th>
                                            <th>Department</th>
                                            <th>User</th>
                                            <th>Assigned User</th>
                                            <th>Note</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="deviated_components.length === 0">
                                            <td colspan="14" class="text-center py-4 text-muted">No records found</td>
                                        </tr>
                                        <template v-else>
                                            <tr
                                                v-for="(deviated_component, key) in deviated_components"
                                                :key="key"
                                            >
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        :value="deviated_component.user_equipment_component_id"
                                                        v-model="selectedComponents"
                                                    />
                                                </td>
                                                <td>{{ deviated.from + key }}</td>
                                                <td class="text-center">
                                                    <button
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#remarkModal"
                                                        @click="addRemark(deviated_component)"
                                                        class="btn btn-xs btn-primary"
                                                    >
                                                        <i class="fa fa-add"></i>
                                                    </button>
                                                </td>
                                                <td>{{ deviated_component.template_name }}</td>
                                                <td>{{ deviated_component.equipment }}</td>
                                                <td>{{ deviated_component.date_time }}</td>
                                                <td>{{ deviated_component.component_type?.component_type_name }}</td>
                                                <td>{{ deviated_component.check_type?.check_type_name }}</td>
                                                <td>{{ deviated_component.default_value }}</td>
                                                <td>{{ deviated_component.value }}</td>
                                                <td>{{ deviated_component.user_template?.department?.department_name }}</td>
                                                <td>{{ deviated_component.user_template?.user?.name }}</td>
                                                <td>{{ deviated_component?.assigned_user?.user?.name }}</td>
                                                <td>{{ deviated_component.note }}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="form-actions-footer" v-if="deviated.totalRows > 0">
                            <div class="text-end row">
                                <div class="col-sm-2">
                                    <select
                                        class="form-control"
                                        v-model="deviated.per_page"
                                        @change="onDeviatedPerPageChange"
                                    >
                                        <option>10</option>
                                        <option>15</option>
                                        <option>20</option>
                                        <option>25</option>
                                        <option>30</option>
                                    </select>
                                </div>
                                <div class="col-sm-10">
                                    <Pagination
                                        class="pagination pagination-sm"
                                        :maxPage="deviated.maxPage"
                                        :totalPages="deviated.lastPage"
                                        :currentPage="deviated.page"
                                        @pagechanged="onDeviatedPageChange"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card" v-else-if="deviationFilter === 'my'">
                        <div class="card-body">
                            <div class="table-responsive tabletop">
                                <table class="table table-sm table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th><input type="checkbox" disabled /></th>
                                            <th>#</th>
                                            <th class="text-center">Action</th>
                                            <th>Template Name</th>
                                            <th>Equipment</th>
                                            <th>Date Time</th>
                                            <th>Component Type</th>
                                            <th>Check Type</th>
                                            <th>Default</th>
                                            <th>Value</th>
                                            <th>Department</th>
                                            <th>User</th>
                                            <th>Assigned User</th>
                                            <th>Note</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td colspan="14" class="text-center py-4 text-muted">No data found</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="row gutters"
                v-if="meta.department_id && (resolved_components.length > 0 || akxaChecklistNoApi)"
            >
                <div class="col-sm-12">
                    <h5>Resolved Components ({{ resolved.totalRows }}) : {{ plant_code }} : {{ department_name }}</h5>
                    <div class="card">
                        <div class="card-body">
                            <div class="table-responsive tabletop">
                                <table class="table table-sm table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Template Name</th>
                                            <th>Date Time</th>
                                            <th>Component Type</th>
                                            <th>Check Type</th>
                                            <th>Default</th>
                                            <th>Value</th>
                                            <th>Department</th>
                                            <th>User</th>
                                            <th>Note</th>
                                            <th>Remark</th>
                                            <th>Remarked By</th>
                                            <th>Remark Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="resolved_components.length === 0">
                                            <td colspan="13" class="text-center py-4 text-muted">No records found</td>
                                        </tr>
                                        <template v-else>
                                            <tr
                                                v-for="(resolved_component, key) in resolved_components"
                                                :key="key"
                                            >
                                                <td>{{ resolved.from + key }}</td>
                                                <td>{{ resolved_component.template_name }}</td>
                                                <td>{{ resolved_component.date_time }}</td>
                                                <td>{{ resolved_component.component_type?.component_type_name }}</td>
                                                <td>{{ resolved_component.check_type?.check_type_name }}</td>
                                                <td>{{ resolved_component.default_value }}</td>
                                                <td>{{ resolved_component.value }}</td>
                                                <td>{{ resolved_component.user_template?.department?.department_name }}</td>
                                                <td>{{ resolved_component.user_template?.user?.name }}</td>
                                                <td>{{ resolved_component.note }}</td>
                                                <td>{{ resolved_component.remark }}</td>
                                                <td>{{ resolved_component?.remark_user?.name }}</td>
                                                <td>{{ resolved_component.remark_date_time }}</td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="card-footer" v-if="resolved.totalRows > 0">
                            <Pagination
                                class="pagination pagination-sm"
                                :maxPage="resolved.maxPage"
                                :totalPages="resolved.lastPage"
                                :currentPage="resolved.page"
                                @pagechanged="onResolvedPageChange"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Modals -->
    <div class="modal fade" id="remarkModal" tabindex="-1" data-bs-backdrop="false">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Update Remark</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="field-wrapper">
                        <div class="field-placeholder">Remark *</div>
                        <textarea
                            class="form-control"
                            v-model="remark.remark"
                            :class="{ 'is-invalid': errors.remark }"
                            placeholder="Enter Remark"
                        ></textarea>
                        <span v-if="errors.remark" class="invalid-feedback">{{ errors.remark[0] }}</span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" @click="updateRemark()" class="btn btn-primary">
                        Update
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="multiRemarkModal" tabindex="-1" ref="multiRemarkModal" data-bs-backdrop="false">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Update Remarks</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="field-wrapper">
                        <div class="field-placeholder">Remark *</div>
                        <textarea
                            class="form-control"
                            v-model="multiRemark"
                            :class="{ 'is-invalid': errors.multiRemark }"
                            placeholder="Enter Remarks"
                        ></textarea>
                        <span v-if="errors.multiRemark" class="invalid-feedback">{{ errors.multiRemark[0] }}</span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="submit" @click="updateMultipleRemarks" class="btn btn-primary">
                        Update
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="assignUserModal" tabindex="-1" ref="assignUserModal" data-bs-backdrop="false">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Assign User</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="field-wrapper">
                        <div class="field-placeholder">User *</div>
                        <select
                            class="form-control"
                            v-model="assignUser.user_id"
                            :class="{ 'is-invalid': errors.user_id }"
                        >
                            <option value="">Select User</option>
                            <option v-for="(user, key) in plantUsers" :key="key" :value="user.user_id">
                                {{ user.name }}
                            </option>
                        </select>
                        <span v-if="errors.user_id" class="invalid-feedback">{{ errors.user_id[0] }}</span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" @click="assignUserToComponent()" class="btn btn-primary">Assign</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import Pagination from "@/components/Pagination.vue";

    export default {
        name: "ChecklistTab",
        components: { Pagination },
        props: {
            akxaChecklistNoApi: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                meta: {
                    user_id: this.$store.getters.user?.user_id,
                    role_id: this.$store.getters.user?.role_id,
                    plant_id: "",
                    department_id: "",
                    frequency_id: "",
                    from_date: "",
                    to_date: "",
                },
                deviated: {
                    order_by: "asc",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    maxPage: 1,
                },
                resolved: {
                    order_by: "asc",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    maxPage: 1,
                },
                frequency_name: "",
                plant_code: "",
                department_name: "",
                frequency_compliance: null,
                frequencies: [],
                plants: [],
                departments: [],
                deviated_components: [],
                resolved_components: [],
                errors: [],
                selectedComponents: [],
                allSelected: false,
                deviationFilter: "all",
                remark: {
                    user_id: this.$store.getters.user?.user_id,
                    user_equipment_component_id: "",
                    remark: "",
                },
                multiRemark: "",
                plantUsers: [],
                assignUser: {
                    user_id: "",
                    user_equipment_component_id: "",
                },
            };
        },
        mounted() {
            let vm = this;
            if (vm.akxaChecklistNoApi) {
                vm.bootstrapAkxaChecklistWithoutApi();
            } else {
                vm.getFrequencies();
            }
        },
        watch: {
            selectedComponents(newVal) {
                this.allSelected = newVal.length === this.deviated_components.length && newVal.length > 0;
            },
        },
        methods: {
            bootstrapAkxaChecklistWithoutApi() {
                let vm = this;
                vm.frequencies = [
                    { frequency_id: 99001, frequency_name: "Daily" },
                    { frequency_id: 99002, frequency_name: "Weekly" },
                    { frequency_id: 99003, frequency_name: "Monthly" },
                ];
                vm.meta.frequency_id = 99001;
                vm.updateFromDateToDate();
            },
            applyAkxaFullDrilldownSeed() {
                let vm = this;
                const u = vm.$store.getters.user;
                if (!u) {
                    return;
                }
                let pid = vm.meta.plant_id;
                if (pid === "" || pid == null) {
                    pid =
                        u.plant_id != null && u.plant_id !== ""
                            ? u.plant_id
                            : u.plant && u.plant.plant_id;
                }
                let pcode = vm.plant_code;
                if (!pcode || pcode === "") {
                    if (u.plant && u.plant.plant_code) {
                        pcode = u.plant.plant_code;
                    } else if (u.plant_code) {
                        pcode = u.plant_code;
                    } else {
                        pcode = "AKXA";
                    }
                }
                vm.meta.plant_id = pid;
                vm.plant_code = pcode;
                vm.plants = [
                    {
                        plant_id: pid,
                        plant_code: pcode,
                        compliance: 70,
                        expected: 0,
                        submitted: 0,
                    },
                ];
                vm.departments = [
                    {
                        department_id: 99101,
                        department_name: "Mechanical",
                        compliance: 100,
                        deviated_componenets: 0,
                        expected: 0,
                        submitted: 0,
                    },
                    {
                        department_id: 99102,
                        department_name: "Electrical",
                        compliance: 40,
                        deviated_componenets: 0,
                        expected: 0,
                        submitted: 0,
                    },
                ];
                vm.meta.department_id = vm.departments[0].department_id;
                vm.department_name = vm.departments[0].department_name;
                vm.fillAkxaDeviatedResolvedRows();
            },
            fillAkxaDeviatedResolvedRows() {
                let vm = this;
                vm.deviated_components = [];
                vm.deviated.totalRows = 0;
                vm.deviated.lastPage = 1;
                vm.deviated.from = 1;
                vm.deviated.maxPage = 1;
                vm.resolved_components = [];
                vm.resolved.totalRows = 0;
                vm.resolved.lastPage = 1;
                vm.resolved.from = 1;
                vm.resolved.maxPage = 1;
                vm.selectedComponents = [];
                vm.allSelected = false;
            },
            toggleSelectAll() {
                if (this.allSelected) {
                    this.selectedComponents = [];
                } else {
                    this.selectedComponents = this.deviated_components.map((dc) => dc.user_equipment_component_id);
                }
                this.allSelected = !this.allSelected;
            },
            getColor(value) {
                if (value >= 80) {
                    return "green";
                } else if (value >= 50) {
                    return "orange";
                } else if (value == "NA") {
                    return "gray";
                } else {
                    return "red";
                }
            },
            getFrequencies() {
                let vm = this;
                if (vm.akxaChecklistNoApi) {
                    vm.bootstrapAkxaChecklistWithoutApi();
                    return;
                }
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getDashboardFrequencies", data: vm.meta })
                    .then(function (response) {
                        loader.hide();
                        vm.frequencies = response.data.data;
                        if (vm.frequencies.length != 0) {
                            vm.meta.frequency_id = vm.frequencies[0].frequency_id;
                            vm.updateFromDateToDate();
                        }
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            updateFromDateToDate() {
                let vm = this;
                let frequencies = vm.frequencies.filter((frequency) => {
                    return vm.meta.frequency_id == frequency.frequency_id;
                });
                let frequency = frequencies[0];
                vm.frequency_name = frequencies[0].frequency_name;
                vm.meta.from_date = "";
                vm.meta.to_date = "";
                if (frequency.frequency_name.includes("Daily")) {
                    vm.meta.from_date = moment().subtract(1, "days").format("YYYY-MM-DD");
                    vm.meta.to_date = moment().subtract(1, "days").format("YYYY-MM-DD");
                } else if (frequency.frequency_name.includes("Weekly")) {
                    vm.meta.from_date = moment().subtract(1, "weeks").startOf("isoWeek").format("YYYY-MM-DD");
                    vm.meta.to_date = moment().subtract(1, "weeks").endOf("isoWeek").format("YYYY-MM-DD");
                } else if (frequency.frequency_name.includes("Fortnightly")) {
                    const today = moment();

                    if (today.date() <= 15) {
                        vm.meta.from_date = today.subtract(1, "month").date(16).format("YYYY-MM-DD");
                        vm.meta.to_date = today.endOf("month").format("YYYY-MM-DD");
                    } else {
                        vm.meta.from_date = today.startOf("month").format("YYYY-MM-DD");
                        vm.meta.to_date = today.date(15).format("YYYY-MM-DD");
                    }
                } else if (frequency.frequency_name.includes("Monthly")) {
                    vm.meta.from_date = moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD");
                    vm.meta.to_date = moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD");
                } else {
                    vm.meta.from_date = moment().startOf("month").format("YYYY-MM-DD");
                    vm.meta.to_date = moment().subtract(1, "days").format("YYYY-MM-DD");
                }
                vm.frequency_compliance = null;
                vm.plants = [];
                vm.departments = [];
                vm.deviated_components = [];
                vm.resolved_components = [];
                if (vm.akxaChecklistNoApi) {
                    vm.frequency_compliance = 70;
                    vm.applyAkxaFullDrilldownSeed();
                } else {
                    vm.getClusterFrequenceCompliance();
                }
            },
            getClusterFrequenceCompliance() {
                let vm = this;
                if (vm.akxaChecklistNoApi) {
                    vm.frequency_compliance = 100;
                    vm.applyAkxaFullDrilldownSeed();
                    return;
                }
                vm.plants = [];
                vm.departments = [];
                vm.deviated_components = [];
                vm.resolved_components = [];
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getClusterFrequenceCompliance", data: vm.meta })
                    .then(function (response) {
                        vm.frequency_compliance = response.data["compliance"];
                        loader.hide();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getClusterPlantCompliance() {
                let vm = this;
                if (vm.akxaChecklistNoApi) {
                    vm.frequency_compliance = 100;
                    vm.applyAkxaFullDrilldownSeed();
                    return;
                }
                vm.plants = [];
                vm.departments = [];
                vm.deviated_components = [];
                vm.resolved_components = [];
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getClusterPlantCompliance", data: vm.meta })
                    .then(function (response) {
                        vm.plants = response.data;
                        loader.hide();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getClusterDepartmentCompliance(plant_id, plant_code) {
                let vm = this;
                if (vm.akxaChecklistNoApi) {
                    vm.meta.plant_id = plant_id;
                    vm.plant_code = plant_code;
                    vm.frequency_compliance = 100;
                    vm.applyAkxaFullDrilldownSeed();
                    return;
                }
                vm.meta.plant_id = plant_id;
                vm.plant_code = plant_code;
                vm.departments = [];
                vm.deviated_components = [];
                vm.resolved_components = [];
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getClusterDepartmentCompliance", data: vm.meta })
                    .then(function (response) {
                        vm.departments = response.data;
                        loader.hide();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            selectDepartment(department) {
                let vm = this;
                vm.meta.department_id = department.department_id;
                vm.department_name = department.department_name;
                if (vm.akxaChecklistNoApi) {
                    vm.fillAkxaDeviatedResolvedRows();
                    return;
                }
                vm.getClusterDeviatedComponents();
                vm.getClusterResolvedComponents();
            },
            getClusterDeviatedComponents() {
                let vm = this;
                if (vm.akxaChecklistNoApi) {
                    vm.fillAkxaDeviatedResolvedRows();
                    return;
                }
                let loader = vm.$loading.show();
                const requestData = {
                    ...vm.meta,
                    ...vm.deviated,
                    deviation_filter: vm.deviationFilter,
                };

                if (vm.deviationFilter === "my") {
                    requestData.assigned_user_id = vm.$store.getters.user?.user_id || vm.meta.user_id;
                }

                vm.$store
                    .dispatch("post", { uri: "getClusterDeviatedComponents", data: requestData })
                    .then(function (response) {
                        loader.hide();
                        vm.deviated_components = response.data.data;
                        vm.deviated.totalRows = response.data.meta.total;
                        vm.deviated.lastPage = response.data.meta.last_page;
                        vm.deviated.from = response.data.meta.from;
                        vm.deviated.maxPage = vm.deviated.lastPage >= 3 ? 3 : vm.deviated.lastPage;
                        vm.allSelected = vm.deviated_components.every((dc) =>
                            vm.selectedComponents.includes(dc.user_equipment_component_id)
                        );
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            onDeviationFilterChange() {
                let vm = this;
                vm.deviated.page = 1;
                vm.selectedComponents = [];
                vm.allSelected = false;
                vm.getClusterDeviatedComponents();
            },
            getClusterResolvedComponents() {
                let vm = this;
                if (vm.akxaChecklistNoApi) {
                    vm.fillAkxaDeviatedResolvedRows();
                    return;
                }
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getClusterResolvedComponents", data: { ...vm.meta, ...vm.resolved } })
                    .then(function (response) {
                        loader.hide();
                        vm.resolved_components = response.data.data;
                        vm.resolved.totalRows = response.data.meta.total;
                        vm.resolved.lastPage = response.data.meta.last_page;
                        vm.resolved.from = response.data.meta.from;
                        vm.resolved.maxPage = vm.resolved.lastPage >= 3 ? 3 : vm.resolved.lastPage;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            addRemark(user_equipment_component) {
                let vm = this;
                vm.remark.user_equipment_component_id = user_equipment_component?.user_equipment_component_id;
                vm.remark.remark = user_equipment_component?.remark;
            },
            openMultiRemarkModal() {
                let vm = this;
                vm.multiRemark = "";
                vm.errors = {};
            },
            openAssignUserModal() {
                let vm = this;
                vm.assignUser.user_id = "";
                vm.assignUser.user_equipment_component_id = "";
                vm.errors = {};
                vm.getPlantUsers();
            },
            getPlantUsers() {
                let vm = this;
                if (vm.akxaChecklistNoApi) {
                    vm.plantUsers = [];
                    return;
                }
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "getPlantUsers", data: vm.meta })
                    .then(function (response) {
                        loader.hide();
                        vm.plantUsers = response.data.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            updateRemark() {
                let vm = this;
                if (vm.akxaChecklistNoApi) {
                    vm.$store.dispatch("error", "Checklist is shown locally for AKXA plant (no server update).");
                    return;
                }
                let loader = vm.$loading.show();
                let uri = { uri: "updateDeviatedRemarks", data: vm.remark };
                vm.$store
                    .dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        vm.remark.user_equipment_component_id = "";
                        vm.remark.remark = "";
                        vm.$store.dispatch("success", "Remark is successfully updated");
                        vm.getClusterDeviatedComponents();
                        vm.getClusterResolvedComponents();
                        
                        // Close modal using Bootstrap API
                        vm.$nextTick(() => {
                            const modalEl = document.getElementById('remarkModal');
                            if (modalEl) {
                                if (window.bootstrap && window.bootstrap.Modal) {
                                    const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
                                    if (modalInstance) {
                                        modalInstance.hide();
                                    } else {
                                        modalEl.classList.remove('show');
                                        modalEl.setAttribute('aria-hidden', 'true');
                                        modalEl.style.display = 'none';
                                        document.body.classList.remove('modal-open');
                                        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
                                    }
                                } else {
                                    modalEl.classList.remove('show');
                                    modalEl.setAttribute('aria-hidden', 'true');
                                    modalEl.style.display = 'none';
                                    document.body.classList.remove('modal-open');
                                    document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
                                }
                            }
                        });
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            updateMultipleRemarks() {
                let vm = this;
                if (vm.akxaChecklistNoApi) {
                    vm.$store.dispatch("error", "Checklist is shown locally for AKXA plant (no server update).");
                    return;
                }
                vm.errors = {};

                if (!vm.multiRemark.trim()) {
                    vm.errors.multiRemark = ["Remark is required."];
                    return;
                }

                if (vm.selectedComponents.length === 0) {
                    vm.$store.dispatch("error", "Please select at least one component.");
                    return;
                }

                const selectedObjects = vm.deviated_components.filter((dc) =>
                    vm.selectedComponents.includes(dc.user_equipment_component_id)
                );
                const payload = {
                    deviated_components: selectedObjects,
                    remark: vm.multiRemark.trim(),
                    user_id: vm.$store.getters.user?.user_id,
                };

                const loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", {
                        uri: "bulkupdateDeviatedRemarks",
                        data: payload,
                    })
                    .then(() => {
                        loader.hide();
                        vm.selectedComponents = [];
                        vm.multiRemark = "";
                        vm.allSelected = false;

                        vm.$store.dispatch("success", "Remarks updated successfully.");
                        vm.getClusterDeviatedComponents();
                        vm.getClusterResolvedComponents();

                        vm.$nextTick(() => {
                            const modalEl = document.getElementById("multiRemarkModal");
                            if (modalEl) {
                                if (window.bootstrap && window.bootstrap.Modal) {
                                    const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
                                    if (modalInstance) {
                                        modalInstance.hide();
                                    } else {
                                        modalEl.classList.remove('show');
                                        modalEl.setAttribute('aria-hidden', 'true');
                                        modalEl.style.display = 'none';
                                        document.body.classList.remove('modal-open');
                                        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
                                    }
                                } else {
                                    modalEl.classList.remove('show');
                                    modalEl.setAttribute('aria-hidden', 'true');
                                    modalEl.style.display = 'none';
                                    document.body.classList.remove('modal-open');
                                    document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
                                }
                            }
                            
                            setTimeout(() => {
                                document.body.classList.remove('modal-open');
                                document.body.style.overflow = '';
                                document.body.style.paddingRight = '';
                                document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
                            }, 100);
                        });
                    })
                    .catch((error) => {
                        loader.hide();
                        vm.errors = error.response?.data?.errors || {};
                        vm.$store.dispatch("error", error.response?.data?.message || "An error occurred");
                    });
            },
            assignUserToComponent() {
                let vm = this;
                if (vm.akxaChecklistNoApi) {
                    vm.$store.dispatch("error", "Checklist is shown locally for AKXA plant (no server update).");
                    return;
                }
                vm.errors = {};

                if (!vm.assignUser.user_id || vm.assignUser.user_id === "" || vm.assignUser.user_id === null) {
                    vm.errors.user_id = ["User is required."];
                    return;
                }

                if (vm.selectedComponents.length === 0) {
                    vm.$store.dispatch("error", "Please select at least one component.");
                    return;
                }

                const loader = vm.$loading.show();

                vm.$store
                    .dispatch("post", {
                        uri: "assignUserToComponent",
                        data: {
                            user_id: vm.assignUser.user_id,
                            user_equipment_component_ids: vm.selectedComponents,
                        },
                    })
                    .then(() => {
                        loader.hide();
                        vm.assignUser.user_id = "";
                        vm.assignUser.user_equipment_component_id = "";
                        vm.selectedComponents = [];
                        vm.allSelected = false;
                        vm.$store.dispatch("success", "User assigned successfully.");

                        vm.$nextTick(() => {
                            const modalEl = document.getElementById("assignUserModal");
                            if (modalEl) {
                                const closeButton = modalEl.querySelector('button[data-bs-dismiss="modal"]');
                                if (closeButton) {
                                    closeButton.click();
                                } else {
                                    if (window.bootstrap && window.bootstrap.Modal) {
                                        const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
                                        if (modalInstance) {
                                            modalInstance.hide();
                                        }
                                    } else {
                                        modalEl.classList.remove("show");
                                        modalEl.setAttribute("aria-hidden", "true");
                                        modalEl.style.display = "none";
                                        document.body.classList.remove("modal-open");
                                        document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
                                    }
                                }
                            }
                        });

                        vm.getClusterDeviatedComponents();
                        vm.getClusterResolvedComponents();
                    })
                    .catch((error) => {
                        loader.hide();
                        vm.errors = error.response?.data?.errors || {};
                        vm.$store.dispatch("error", error.response?.data?.message || "An error occurred");
                    });
            },
            onDeviatedPageChange(page) {
                this.deviated.page = page;
                if (this.akxaChecklistNoApi) {
                    this.fillAkxaDeviatedResolvedRows();
                    return;
                }
                this.getClusterDeviatedComponents();
            },
            onDeviatedPerPageChange() {
                this.deviated.page = 1;
                if (this.akxaChecklistNoApi) {
                    this.fillAkxaDeviatedResolvedRows();
                    return;
                }
                this.getClusterDeviatedComponents();
            },
            onResolvedPageChange(page) {
                this.resolved.page = page;
                if (this.akxaChecklistNoApi) {
                    this.fillAkxaDeviatedResolvedRows();
                    return;
                }
                this.getClusterResolvedComponents();
            },
        },
    };
</script>

<style scoped>
    #label,
    h6 {
        color: #fff !important;
    }

    .card .card-body {
        padding: 10px;
    }

    .card .card-footer {
        padding: 10px;
    }

    .table {
        margin-bottom: 0rem;
    }

    .btn-xs {
        padding: 1px;
        margin: 1px;
    }

    .checklist-wrapper {
        width: 100%;
    }

    .checklist-filter-section {
        position: sticky;
        top: 0;
        padding: 15px;
        margin: 0;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        border-bottom: 1px solid #e0e0e0;
        z-index: 0;
    }

    .checklist-filter-section .card {
        margin-bottom: 0;
    }

    .checklist-content {
        padding: 15px;
    }

    .checklist-content .row {
        margin-left: -15px;
        margin-right: -15px;
    }

    .checklist-content .row > [class*="col-"] {
        padding-left: 15px;
        padding-right: 15px;
    }

    .checklist-sticky-section {
        padding-bottom: 10px;
        margin-bottom: 15px;
        padding-top: 10px;
    }

    .dashboard-header {
        width: 100%;
        overflow: visible;
    }

    .dashboard-header-content {
        width: 100%;
        margin: 0;
        padding: 0;
    }

    .sales-tile-container {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        width: 100%;
        margin: 0;
        padding: 0;
    }

    .sales-tile {
        cursor: pointer;
        margin: 0;
        padding: 12px;
        border-radius: 12px;
        text-align: center;
        transition: all 0.3s;
        min-width: 140px;
        flex: 0 0 auto;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
</style>
